import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import PublicHeader from '../Header/PublicHeader';
import Footer from '../Footer';
import { ArrowRight } from 'react-bootstrap-icons'
import {
  CalendarEvent,
  GeoAlt,
  Trophy,
  People,
  Clock,
  CheckCircle,
  Whatsapp
} from 'react-bootstrap-icons';
import img from "../../Assets/img/aiccc25.jpg";
import img2 from "../../Assets/img/Marriott Navi Mumbai.jpg";
import calendarIcon from "../../Assets/img/icons/calendar.png";
import locationIcon from "../../Assets/img/icons/place.png";
const events = [
  {
    title: "All India Convention Of Career Counsellors & Awards 2026",
    date: ' 8th August 2026 (Saturday)',
    location: 'Marriott, Navi Mumbai',
    image: img2,
    description: 'AICCC 2026 isn’t just another event. It’s India’s premier gathering of Career Counsellors, Educators, and Industry Leaders where ideas ignite, connections turn into collaborations, and insights turn into impact. Whether you’re an established Career Guidance Professional, an Educator advocating change, or an aspiring Career Counsellor, this is where you belong.',
    isOpen: false,
    registerLink: "https://aiccc.co.in/",

  },
  // {
  //   title: "CONNECT (Counsellors' Networking, Collaboration & Training) Meet",
  //   date: '27 March 2025 (Thursday)',
  //   location: 'IILM University, Gurugram ',
  //   image: img,
  //   description: 'Sessions on Emotional First Aid & Career Advancement Tools ,Workshop on AI enabled Digital Literacy & Tools for K12 Schools ,Discussion on Higher Education Pathways in India ,Q&A Session, Certification to all participants ,Networking lunch'
  // },
  {
    title: "All India Convention Of Career Counsellors & Awards 2025",
    date: '23 August 2025 (Saturday)',
    location: 'Pride Plaza Hotel, Aerocity, New Delhi',
    image: img,
    isOpen: false,
  },

];

// Animation variants
const fadeIn = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
};
const fadeInLeft = {
  hidden: { opacity: 0, x: -40 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.6 } },
};

const fadeInRight = {
  hidden: { opacity: 0, x: 40 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.6 } },
};
const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};

const EventCard = ({ event, index }) => {
  return (
    <motion.div
      className={`bg-white shadow-xl rounded-xl overflow-hidden max-w-full w-full flex flex-col md:flex-row ${index % 2 !== 0 ? 'md:flex-row-reverse' : ''}`}
      whileHover={{
        y: -8,
        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
      }}
      transition={{ duration: 0.3 }}
      variants={fadeIn}
    >

      {/* Image Section */}
      <div className="w-full md:w-1/2 p-3">
        <img
          src={event.image}
          alt={event.title}
          className="w-auto h-48 md:h-72 object-cover rounded-2xl shadow-md"
        />
      </div>

      {/* Text Section */}
      <div className='w-full p-6 flex flex-col justify-between md:w-full'>
        <div>
          <h4 className='text-xl font-bold text-gray-800 mb-3'>{event.title}</h4>
          <div className="flex items-center gap-6 mb-2">
            <div className="flex items-center gap-2 text-[#0d73b9] font-semibold text-md">
              <img src={calendarIcon} alt="Date" className="w-4 h-4" />
              <span>{event.date}</span>
            </div>
          </div>
          <div className="flex items-center gap-6 mb-2">
            <div className="flex items-center gap-2 text-[#0d73b9] font-semibold text-md">
              <img src={locationIcon} alt="Location" className="w-4 h-4" />
              <span>{event.location}</span>
            </div>
          </div>
          <p className='text-gray-600 text-md leading-relaxed mb-4 py-1 leading-relaxed text-justify'>{event.description}</p>
        </div>
        <div className="flex flex-col sm:flex-row sm:justify-between gap-4 mt-1">
          {event.isOpen ? (
            <button
              className="px-5 py-2 text-white text-sm font-bold rounded-lg"
              style={{
                background:
                  "linear-gradient(180deg, #0078BF 0%, #244183 100%)",
              }}
              onClick={() => window.open(event.registerLink, "_blank")}
            >
              Register Now
            </button>
          ) : (
            <button
              className="px-5 py-2 text-gray-600 text-sm font-bold rounded-lg"
              style={{
                background: "#e5e7eb",
                cursor: "not-allowed",
              }}
              disabled
            >
              Event Completed
            </button>
          )}
        </div>
      </div>
    </motion.div>
  );
};



const HeroSection = () => (
  <section
    className='relative text-white overflow-hidden'
    style={{ background: "linear-gradient(180deg, #0078BF 0%, #244183 100%)" }}
  >
    <div className='absolute inset-0 opacity-10'>
      <div className='absolute top-0 left-0 w-full h-full bg-pattern-dots'></div>
    </div>
    <div className='container mx-auto px-4 sm:px-6 py-6 sm:py-10 relative z-10'>
      <motion.div
        className='max-w-4xl mx-auto text-center'
        initial="hidden"
        animate="visible"
        variants={staggerContainer}
      >
        <motion.h1
          className='text-3xl sm:text-4xl md:text-6xl font-bold mb-4 sm:mb-6 leading-snug'
          variants={fadeIn}
        >
          Annual Events
        </motion.h1>
      </motion.div>
    </div>
  </section>
);



const FeatureSection = () => {
  const features = [
    {
      icon: <Trophy size={32} className="text-[#0d73b9]" />,
      title: "Learn from the Best",
      description: "Gain insights from industry pioneers and thought leaders who are shaping the future of education and careers."
    },
    {
      icon: <People size={32} className="text-[#0d73b9]" />,
      title: "Network with Purpose",
      description: "Connect with a vibrant community of career counsellors, educators, and professionals who share your passion."
    },
    {
      icon: <Clock size={32} className="text-[#0d73b9]" />,
      title: "Actionable Takeaways",
      description: "Walk away with practical tools, strategies, and resources you can implement immediately."
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-800">Why Attend Our Events?</h2>
          <div className="w-16 h-1 bg-[#0d73b9] mx-auto mt-4"></div>
        </div>

        <motion.div
          className="grid grid-cols-1 md:grid-cols-3 gap-10"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={staggerContainer}
        >
          {features.map((feature, index) => (
            <motion.div
              key={index}
              className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow border border-gray-100"
              variants={fadeIn}
            >
              <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mb-6 mx-auto">
                {feature.icon}
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4 text-center">{feature.title}</h3>
              <p className="text-gray-600 text-center">{feature.description}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

const EventsSection = () => (
  <section id="events" className='py-10 bg-gray-50'>
    <div className='w-full container mx-auto px-6'>

      {/* Title Section */}
      <div className='text-center mb-6'>
        <h2 className='text-4xl font-bold text-[#0d73b9] mt-2 mb-2'>India’s Largest Gathering of Career Counsellors</h2>
        <span className='text-[#0d73b9] font-semibold text-lg uppercase tracking-wider'>200+ Visitors | 50+ Exhibitors | 25+ Speakers</span>
        <div className='w-16 h-1 bg-[#0d73b9] mx-auto mt-4'></div>
      </div>

      {/*  YouTube Video Embed */}
      {/* <div className="mb-10 flex justify-center">
        <div className="w-full max-w-2xl aspect-video rounded-2xl overflow-hidden shadow-md">
          <iframe
            width="100%"
            height="100%"
            src="https://www.youtube.com/embed/LIHAz0RJAUA?autoplay=0&mute=1"
            title="YouTube video"
            frameBorder="0"
            allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div> */}
      {/* <div className='text-center mt-4 mb-6'>
        <h2 className='text-3xl font-bold text-[#0d73b9] mt-16 mb-2'>Upcoming Events will be announced soon!!</h2>
      </div> */}

      {/* Event Cards */}
      <motion.div
        className="flex flex-col gap-10 w-full max-w-7xl mx-auto"
        viewport={{ once: true, margin: "-100px" }}
      >
        <div className="flex flex-col gap-10 w-full max-w-7xl mx-auto">
          {events.map((event, index) => (
            <EventCard key={index} event={event} index={index} />
          ))}
        </div>
      </motion.div>

    </div>
  </section>
);

const WhatToExpect = () => {
  const items = [
    {
      title: "Inspiring Keynotes",
      description: "Hear from visionaries who are redefining the career counselling landscape."
    },
    {
      title: "Interactive Workshops",
      description: "Dive deep into topics like emerging career trends, student empowerment, and ethical counselling practices."
    },
    {
      title: "Networking Sessions",
      description: "Build relationships that go beyond the event and open doors to new opportunities."
    },
    {
      title: "Hands-On Experiences",
      description: "Explore real-world applications through campus visits, industry tours, and live demonstrations."
    }
  ];

  return (
    <section className="py-10 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-[#0d73b9]">What to Expect</h2>
          <div className="w-16 h-1 bg-[#0d73b9] mx-auto mt-4"></div>
          <p className="text-gray-600 max-w-2xl mx-auto mt-6">Our events are designed to provide maximum value for career counsellors and education professionals.</p>
        </div>

        <motion.div
          className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={staggerContainer}
        >
          {items.map((item, index) => (
            <motion.div
              key={index}
              className="flex items-start p-6 bg-gray-50 rounded-xl"
              variants={fadeIn}
            >
              <div className="flex-shrink-0 w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 mr-4">
                {index + 1}
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-800 mb-2">{item.title}</h3>
                <p className="text-gray-600">{item.description}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

const WhoShouldAttend = () => {
  const attendees = [
    "Career Counsellors looking to enhance their skills and stay ahead of the curve.",
    "Educators and trainers passionate about student empowerment and holistic development.",
    "Professionals interested in collaborating with a forward-thinking community.",
    "Anyone who believes in the power of transforming lives through career guidance."
  ];

  return (
    <section className="py-20 bg-gray-50 overflow-hidden">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row items-stretch gap-12 max-w-6xl mx-auto min-h-[1px]">

          {/* Left - List */}
          <motion.div
            className="md:w-1/2"
            variants={fadeInLeft}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
          >
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-800 mb-6 text-center md:text-left">
              Who Should Attend?
            </h2>
            <div className="w-16 h-1 bg-[#0d73b9] mb-8 mx-auto md:mx-0"></div>

            <div className="space-y-4">
              {attendees.map((item, index) => (
                <div key={index} className="flex items-start">
                  <div className="flex-shrink-0 w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 mr-3 mt-1">
                    <CheckCircle size={14} />
                  </div>
                  <p className="text-gray-700">{item}</p>
                </div>
              ))}
            </div>
          </motion.div>

          {/* Right - WhatsApp CTA */}
          <motion.div
            className="md:w-1/2 bg-white p-8 rounded-xl shadow-lg border border-gray-100"
            variants={fadeInRight}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
          >
            <h3 className="text-2xl font-bold text-gray-800 mb-6 text-center md:text-left">Ready to Join Us?</h3>
            <p className="text-gray-600 mb-8 text-center md:text-left">
              DM us on WhatsApp to reserve your spot at our next event. Limited seats available!
            </p>
            <a
              href="https://wa.me/9625751947?text=I'm%20interested%20in%20registering%20for%20the%20APCCI%20event"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full px-6 py-4 text-white rounded-lg hover:bg-blue-500 transition flex items-center justify-center font-medium"
              style={{ background: "linear-gradient(180deg, #0078BF 0%, #244183 100%)" }}
            >
              <Whatsapp className="w-5 h-5 mr-2" />
              Register via WhatsApp
            </a>
          </motion.div>

        </div>
      </div>
    </section>
  );
};


const CallToAction = () => (
  <section className="py-16  text-white" style={{ background: "linear-gradient(180deg, #0078BF 0%, #244183 100%" }}>
    <div className="container mx-auto px-6 text-center">
      <h2 className="text-3xl font-bold mb-6">Join Our Next Event</h2>
      <p className="text-blue-100 max-w-2xl mx-auto mb-8">
        Don't miss this opportunity to connect with fellow counsellors, expand your knowledge, and be part of a community that's shaping the future of career guidance.
      </p>
      <a
        href="https://wa.me/9625751947?text=I'm%20interested%20in%20registering%20for%20the%20APCCI%20event"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center justify-center px-8 py-3 bg-white text-[#0d73b9] font-medium rounded-lg hover:bg-blue-50 transition-colors shadow-lg"
      >
        <Whatsapp className="mr-2" />
        Register Now
      </a>
    </div>
  </section>
);

const UpcomingEvents = () => (
  <>
    <PublicHeader />
    <HeroSection />
    <EventsSection />
    <FeatureSection />
    <WhatToExpect />
    <WhoShouldAttend />
    <CallToAction />
    <Footer />
  </>
);

export default UpcomingEvents;